<nav *ngIf="breadcrumbs$ | async as breadcrumbs" class="breadcrumb mb-0">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a class="breadcrumb-item small" *ngIf="!last" [routerLink]="breadcrumb.url">{{ breadcrumb.label | async }}</a>
    <span *ngIf="last" class="breadcrumb-item active small">{{ breadcrumb.label | async }}</span>
  </ng-container>
</nav>
